<template>
  <svg
    class="absolute top-0 left-0"
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
        cx="200"
        cy="200"
        r="83.2607"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="200"
        cy="200"
        r="64.4573"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="199.999"
        cy="200.001"
        r="102.064"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="200.001"
        cy="200.001"
        r="122.577"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="200"
        cy="199.999"
        r="141.38"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="199.999"
        cy="200.001"
        r="161.893"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="200"
        cy="200"
        r="180.697"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
    <circle
        cx="200"
        cy="200"
        r="199.5"
        stroke="#0384FB"
        stroke-opacity="0.3"
    />
  </svg>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>
